module.exports = __webpack_public_path__ + "img/notification_bg.4f772c27.png";